import { recordingActions as ACTIONS, recordingState } from 'src/slices/recordingSlice';
import { Alert, Box, Snackbar, alpha, lighten, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { liveViewActions, liveViewState } from 'src/slices/liveViewSlice';
import { pageNotiActions, pageNotiState } from 'src/slices/pageNotificationSlice';
import { useDispatch, useSelector } from "react-redux";

import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';
import Header from './Header';
import InactivitySessionDialog from '../../components/InactivitySessionDialog';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import UserSessionDialog from '../../components/UserSessionDialog';
import _ from 'lodash';

const ExtendedSidebarLayout = () => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const { recordingProgress } = useSelector(pageNotiState);
  const { selections } = useSelector(liveViewState);
  const { recordings } = useSelector(recordingState);
  const dispatch = useDispatch();
  useEffect(() => {
    let recordingWithStatuses = recordingProgress.recordingWithStatuses;
    _.map(recordingWithStatuses, (x) => {
      _.map(recordings, y => {
        if (y.video_task_id == x.videoTaskId) {
          setOpen(true);
          _.map(selections, s => {
            if (s.deviceId == y.deviceId) {
              if (x.status == "Completed" || x.status == "Error") {
                dispatch(ACTIONS.stopRecording({ deviceId: s.deviceId }))
                dispatch(liveViewActions.updateStopRecordingForSelection(s.layoutId))
                dispatch(pageNotiActions.setRecordingAndArchivedNotifications(x))
              }
            }
          })
        }
      })

    })

  }, [recordingProgress])

  useEffect(() => {
    if (recordings.length == 0) {
      setOpen(false);
    }
    else {
      setOpen(true);
    }
  }, [recordings])

  return (
    <>
      <Box
        sx={{
          flex: 1,
          height: '100%',
          background: '#121731',
          '.MuiPageTitle-wrapper': {
            marginBottom: `${theme.spacing(4)}`,
            boxShadow:
              theme.palette.mode === 'dark'
                ? `0 1px 0 ${alpha(
                  lighten(theme.colors.primary.main, 0.7),
                  0.15
                )}, 0px 2px 4px -3px rgba(0, 0, 0, 0.2), 0px 5px 12px -4px rgba(0, 0, 0, .1)`
                : `0px 2px 4px -3px ${alpha(
                  theme.colors.alpha.black[100],
                  0.1
                )}, 0px 5px 12px -4px ${alpha(
                  theme.colors.alpha.black[100],
                  0.05
                )}`
          }
        }}
      >
        <Header />
        <Sidebar />
        <Box
          sx={{
            position: 'relative',
            zIndex: 5,
            display: 'block',
            flex: 1,
            ml: `${theme.sidebar.width}`
          }}
        >
          <Box display="block" sx={{ overflowX: 'hidden' }}>
            <Outlet />
          </Box>
        </Box>
      </Box>
      <Box>
        <UserSessionDialog />
        <InactivitySessionDialog />
      </Box>
      <Box>
        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          open={open}
          message="Recording in Progress."
          sx={{
            backgroundColor: 'black',
            width: '217px',
            height: '57px',
            '&.MuiSnackbar-root': {
              right: 0,
              bottom: 0,
              position: 'absolute'
            },
            position: 'absolute', borderLeft: '2px solid #FF8389'
          }}
        >
          <Alert
            icon={<FiberManualRecordRoundedIcon sx={{ color: '#FF8389' }} />}
            variant="outlined"
            sx={{
              width: '100%',
              backgroundColor: '#000000',
              color: 'white',
              borderRadius: 0,
              border: '1px solid black',
              height: '56px',
              fontStyle: 'normal',
              fontWeight: '700',
              fontSize: '14px',
              fontFamily: 'lato',
              letterSpacing: '0.16px',
              flexWrap: 'nowrap',
              whiteSpace: 'nowrap',
              padding: '5px'
            }}
          >
            Recording in Progress.
          </Alert>
        </Snackbar>
      </Box>
    </>
  );
};

export default ExtendedSidebarLayout;
